/**
 * 工装尺码参考标准
 */
export const SIZE_OPTIONS = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];

export const SIZE_REFERENCE = {
  S: {
    label: 'S',
    friendlyName: '口袋精灵款',
    tagline: '小巧精致，灵动自如',
    height: '150-160cm',
    weight: '80-100 斤',
    scaleY: 0.97,
    scaleX: 0.95,
  },
  M: {
    label: 'M',
    friendlyName: '元气满满款',
    tagline: '精致秀气，日常百搭',
    height: '160-165cm',
    weight: '100-120 斤',
    scaleY: 0.98,
    scaleX: 0.96,
  },
  L: {
    label: 'L',
    friendlyName: '均衡王者款',
    tagline: '匀称标准，适用面广',
    height: '165-170cm',
    weight: '115-135 斤',
    scaleY: 0.99,
    scaleX: 0.98,
  },
  XL: {
    label: 'XL',
    friendlyName: '稳健有型款',
    tagline: '结实舒适，穿着得体',
    height: '170-175cm',
    weight: '135-150 斤',
    scaleY: 1.0,
    scaleX: 1.0,
  },
  '2XL': {
    label: '2XL',
    friendlyName: '宽适达人款',
    tagline: '宽舒自在，活动便利',
    height: '175-180cm',
    weight: '150-175 斤',
    scaleY: 1.01,
    scaleX: 1.02,
  },
  '3XL': {
    label: '3XL',
    friendlyName: '阔气满满款',
    tagline: '阔版设计，舒适宽裕',
    height: '180-185cm',
    weight: '175-190 斤',
    scaleY: 1.02,
    scaleX: 1.04,
  },
  '4XL': {
    label: '4XL',
    friendlyName: '乐享空间款',
    tagline: '宽松惬意，自在随心',
    height: '185-190cm',
    weight: '190-220 斤',
    scaleY: 1.03,
    scaleX: 1.06,
  },
  '5XL': {
    label: '5XL',
    friendlyName: '顶配舒享款',
    tagline: '超大尺码，尊享舒适',
    height: '190cm 以上',
    weight: '220-240 斤',
    scaleY: 1.04,
    scaleX: 1.08,
  },
};

/** 根据尺码获取参考信息 */
export function getSizeInfo(size) {
  return SIZE_REFERENCE[size] || SIZE_REFERENCE.L;
}

/** 生成下拉选项文案 */
export function getSizeSelectOptions() {
  return SIZE_OPTIONS.map((size) => {
    const info = SIZE_REFERENCE[size];
    return {
      value: size,
      label: `${size} · ${info.friendlyName}（${info.height} / ${info.weight}）`,
    };
  });
}
